import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import customIcons from '../styles/icons';
import { Icon } from '../ui_elements/icons';
import { fonts, colors } from '../styles/theme';
import { mobileItemColor, mobileItemHoverColor } from './theme-nav';

const AvatarWrapper = styled('div')`
  display: block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  overflow: hidden;
  margin: 10px;

  i::before {
    font-size: 16px;
    padding: 0 8px;
  }
  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 1000px) {
    color: ${mobileItemColor};
    border: 0;
    width: 60px;
    height: 60px;
    margin: 15px auto;
    border: 0;
    &:hover {
      color: ${mobileItemHoverColor};
    }
    i {
      &::before {
        font-size: 34px;
        width: 34px;
      }
      &::after {
        /* adds dropdown arrow - mobile */
        ${fonts.icons};
        content: '${customIcons['angle-down']}';
        position: absolute;
        right: 10px;
        line-height: 30px;
        color: inherit;
        margin-left: 3px;
        font-size: 18px;
      }
    }
    & + div {
      margin-top: 10px;
    }
  }
`;

const AvatarImg = styled('img')`
  background: ${colors.white};
  border-radius: 50%;
  max-width: 100%;
`;

const AvatarDefault = styled(Icon)`
  background: ${colors.grey.primaryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  &::before {
    display: block;
    content: '${customIcons.user}';
    color: ${colors.white};
    text-align: center;
    margin: 0 auto;
    font-size: 20px;
  }
`;

const Avatar = (props) => {
  const { src } = props;

  if (src) {
    return (
      <AvatarWrapper>
        <AvatarImg src={src} />
      </AvatarWrapper>
    );
  }
  return (
    <AvatarWrapper>
      <AvatarDefault />
    </AvatarWrapper>
  );
};

Avatar.defaultProps = {
  src: '',
};

Avatar.propTypes = {
  src: PropTypes.string,
};

export default Avatar;
